import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "styled-components";
import cn from "classnames";
import { css } from "styled-components";
import { useMainMenuContext } from "../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var Navbar = function Navbar(_ref) {
  var _cn;
  var children = _ref.children;
  var _useMainMenuContext = useMainMenuContext(),
    className = _useMainMenuContext.className,
    cssProp = _useMainMenuContext.css,
    style = _useMainMenuContext.style,
    dataTestId = _useMainMenuContext['data-testid'],
    dataCy = _useMainMenuContext['data-cy'],
    theme = _useMainMenuContext.theme,
    position = _useMainMenuContext.position,
    isTransparent = _useMainMenuContext.isTransparent,
    isBlurred = _useMainMenuContext.isBlurred,
    activeSubMenu = _useMainMenuContext.activeSubMenu,
    currentBreakpointKey = _useMainMenuContext.currentBreakpointKey;
  var searchOverlayIsOpen = activeSubMenu === 'search' && (currentBreakpointKey === 'md' || currentBreakpointKey === 'lg');
  return /*#__PURE__*/_jsx(_StyledNav, {
    role: "navigation",
    "aria-label": "Men\xFA principal",
    className: cn('main-menu w-full flex justify-center', theme.nav.textColorClassName, position, (_cn = {}, _defineProperty(_cn, theme.nav.backgroundColorClassName, !isTransparent || searchOverlayIsOpen), _defineProperty(_cn, 'top-0 left-0 right-0', position === 'sticky' || position === 'absolute'), _cn), className),
    style: style,
    "data-testid": dataTestId,
    "data-cy": dataCy,
    $_css: isBlurred && !searchOverlayIsOpen ? 'rgba(255, 255, 255, 0)' : '',
    $_css2: isBlurred && !searchOverlayIsOpen ? 'blur(20px)' : 'none',
    $_css3: theme.nav.zIndex,
    $_css4: theme.nav.height.xs,
    $_css5: theme.nav.height.sm,
    $_css6: theme.nav.height.md,
    $_css7: theme.nav.height.lg,
    $_css8: cssProp,
    children: children
  });
};
export default Navbar;
var _StyledNav = /*#__PURE__*/_styled("nav").withConfig({
  componentId: "sc-1k2m1au-0"
})(["\n        background-color: ", ";\n        backdrop-filter: ", ";\n        transition: ", ";\n        z-index: ", ";\n        height: ", "px;\n        ", " {\n          height: ", "px;\n        }\n        ", " {\n          height: ", "px;\n        }\n        ", " {\n          height: ", "px;\n        }\n        ", "\n      "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (props) {
  return props.theme.transition(['background-color', 'color']);
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
}, function (props) {
  return props.theme.breakpoints.up('sm');
}, function (p) {
  return p.$_css5;
}, function (props) {
  return props.theme.breakpoints.up('md');
}, function (p) {
  return p.$_css6;
}, function (props) {
  return props.theme.breakpoints.up('lg');
}, function (p) {
  return p.$_css7;
}, function (p) {
  return p.$_css8;
});